<!-- Menu -->
<aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
  <div class="app-brand demo">
    <a [routerLink]="['/app']" class="app-brand-link">
      <img src="../../assets/img/branding/FG-W.svg" width="75%" />
    </a>

    <a class="layout-menu-toggle menu-link text-large ms-auto">
      <i class="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
      <i class="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
    </a>
  </div>

  <div class="menu-inner-shadow"></div>
  <ng-scrollbar autoHeightDisabled="false" track="vertical" visibility="hover">
    <ul class="menu-inner py-1">
      <ng-container *ngFor="let item of sidebarItems">
        <li class="menu-item" [ngClass]="{'active': item?.isActive, 'open':item?.isOpen}">
          <a (click)="selectSidebarItem(item)" class="menu-link"
            [ngClass]="{'menu-toggle' : item.childItems?.length > 0}">
            <i class="{{item.icon}}" [ngStyle]="{'color': item?.iconColor}"></i>
            <div>{{item.label}}</div>
          </a>
          <ul class="menu-sub" *ngIf="item.childItems?.length > 0">
            <ng-container *ngFor="let child of item.childItems">
              <li class="menu-item" [ngClass]="{'active': child?.isActive, 'open':child?.isOpen}">
                <a (click)="selectSidebarItem(child, item)" class="menu-link"
                  [ngClass]="{'menu-toggle' : child.childItems?.length > 0}">
                  <div>{{child?.label}}</div>
                </a>
                <ul class="menu-sub" *ngIf="child.childItems?.length > 0">
                  <ng-container *ngFor="let secondChild of child?.childItems">
                    <li class="menu-item" [ngClass]="{'active': secondChild?.isActive, 'open':secondChild?.isOpen}">
                      <a (click)="selectSidebarItem(secondChild, child, item)" class="menu-link"
                        [ngClass]="{'menu-toggle' : secondChild?.childItems?.length > 0}">
                        <div>{{secondChild?.label}}</div>
                      </a>
                    </li>
                  </ng-container>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </ng-scrollbar>
</aside>
<!-- / Menu -->
